





































































































import { ActualiteTypeDTO } from "@/model/bean/GeneratedDTOs"
import { Component, Prop, Vue, Watch } from "vue-property-decorator"
import H3TitleView from "../commons/H3TitleView.vue"
import InputWithValidation from "../inputs/InputWithValidation.vue"
import { ValidationObserver } from "vee-validate"
import { ActualiteService } from "@/services/rest/actualite/ActualiteService"
import { InfoReportingService } from "@/services/log/InfoReportingService"
import ColorPicker, { DEFAULT_PICKER_COLOR } from "@/views/generic_components/ColorPicker.vue"
import FormInputLabel from "@/views/inputs/FormInputLabel.vue"

const HEX_REGEX = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/

@Component({
  components: {
    FormInputLabel,
    ColorPicker,
    H3TitleView,
    InputWithValidation,
    ValidationObserver,
  },
})
export default class ActualiteTypesModalView extends Vue {
  @Prop({ required: true }) open!: boolean

  private actualiteService = ActualiteService.INSTANCE
  private infoReportingService = InfoReportingService.INSTANCE

  actualiteTypes: ActualiteTypeDTO[] = []
  actualiteTypeLabels: string[] = []
  selectedActualiteType: ActualiteTypeDTO | null = null
  actualiteType: ActualiteTypeDTO | null = null
  defaultColorType = DEFAULT_PICKER_COLOR
  selectedColor: any = this.defaultColorType
  colorErrorMessage = ""
  isExistingTypeLabel = false

  mounted(): void {
    this.reloadActualiteTypes()
  }

  async reloadActualiteTypes(): Promise<void> {
    this.actualiteTypes = await this.actualiteService.getAllActualiteTypes()
    if (this.actualiteTypes?.length > 0) {
      this.actualiteTypeLabels = this.actualiteTypes.map((type) =>
        this.getActualiteTypeListLabel(type).toLowerCase()
      )
    }
    this.actualiteTypes.push(this.defaultNewActualiteType)
    this.resetFields()
  }

  @Watch("selectedActualiteType")
  updateActualiteType(newValue: ActualiteTypeDTO | null): void {
    if (newValue != null) {
      this.actualiteType = Object.assign({}, newValue)
      this.selectedColor = this.actualiteType?.color || this.defaultColorType
    }
  }

  updateColor(color: string): void {
    this.selectedColor = color
    if (this.actualiteType != null) {
      this.actualiteType.color = this.selectedColor
    }
  }

  validateColor(): boolean {
    this.colorErrorMessage = ""

    if (!this.actualiteType?.color) {
      this.colorErrorMessage = "La couleur est obligatoire"
    } else if (!HEX_REGEX.test(this.actualiteType.color)) {
      // Vérifier si la valeur saisie est un code hexadécimal valide
      this.colorErrorMessage =
        "Le format de la couleur n'est pas valide. Veuillez entrer une couleur au format #RRGGBB ou #RGB."
    }

    return this.colorErrorMessage === ""
  }

  get defaultNewActualiteType(): ActualiteTypeDTO {
    const defaultActualiteType = new ActualiteTypeDTO()
    defaultActualiteType.color = this.defaultColorType
    defaultActualiteType.label = ""
    return defaultActualiteType
  }

  getActualiteTypeListLabel(type: ActualiteTypeDTO): string {
    return type.label || this.$t("actualitesPage.actualite-type-modal.add-new-type").toString()
  }

  emitCloseModale(): void {
    this.resetFields()
    this.$emit("close")
  }

  async saveType(): Promise<void> {
    if (this.actualiteType && this.validateColor()) {
      try {
        const savedLabel = this.actualiteType.label
        const messageKeySuffix = this.actualiteType.id == undefined ? "create" : "update"

        // Sauvegarde
        await this.actualiteService.saveActualiteType(this.actualiteType)
        // Sélectionne le type sauvegardé
        await this.reloadActualiteTypes()
        this.updateSelectedTypeByLabel(savedLabel)

        // Affiche le message de succès
        this.infoReportingService.success(
          this.$t("actualitesPage.actualite-type-modal.confirm-" + messageKeySuffix).toString()
        )
      } catch (e) {
        this.infoReportingService.error(this.getErrorStatusText(e.statusText), e as Error)
      }
    }
  }

  updateSelectedTypeByLabel(label: string): void {
    if (!label) {
      this.selectedActualiteType = null
    } else {
      const actualiteType = this.actualiteTypes.find((type) => type.label === label)
      this.selectedActualiteType = actualiteType ? actualiteType : null
    }
  }

  deleteType(event: Event): void {
    event.stopPropagation()
    if (this.actualiteType?.id) {
      const actualiteTypeId = this.actualiteType.id
      this.infoReportingService.dialog(
        this.$t("graePage.confirmation").toString(),
        this.$t("actualitesPage.delete-type").toString(),
        this.$t("actualitesPage.confirm-delete").toString(),
        () => this.doDeleteType(actualiteTypeId),
        "is-danger"
      )
    }
  }

  async doDeleteType(actualiteTypeId: string): Promise<void> {
    try {
      await this.actualiteService.deleteActualiteType(actualiteTypeId)
      await this.reloadActualiteTypes()

      this.infoReportingService.success(
        this.$t("actualitesPage.actualite-type-modal.pop-up-confirm-delete").toString()
      )
    } catch (e) {
      this.infoReportingService.error(this.getErrorStatusText(e.statusText), e as Error)
    }
  }

  getErrorStatusText(errorStatusText: string | undefined): string {
    return errorStatusText ? JSON.parse(errorStatusText)?.error : ""
  }

  resetFields(): void {
    this.selectedActualiteType = null
    this.actualiteType = null
  }

  checkExistingLabel(): void {
    if (this.actualiteType?.label) {
      this.isExistingTypeLabel =
        this.actualiteTypeLabels.includes(this.actualiteType.label.toLowerCase()) &&
        this.selectedActualiteType?.label.toLocaleLowerCase() !=
          this.actualiteType?.label.toLowerCase()
    }
  }
}
